import { useNavigate } from 'react-router-dom';
import BackgroundContainer from 'components/shared/backgroundContainer';
import ForgottenPasswordForm from '../../shared/forgottenPasswordForm';
import { useTranslations } from '../../../utility/useTranslations';
import { APP_PAGES } from '../../../constants/pages';

const ForgottenPasswordPage = props => {
  const translations = useTranslations(APP_PAGES.FORGOTTEN_PASSWORD);
  const navigate = useNavigate();

  return (
    <BackgroundContainer translations={translations.authContainer}>
      <ForgottenPasswordForm
        {...props}
        translations={translations}
        navigate={navigate}
      />
    </BackgroundContainer>
  );
};

export default ForgottenPasswordPage;
